import { Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Spacing } from '@zep/ui';
import { Tabs, TabsContent, TabsList } from '@zep/ui/experimental';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../PlanPaymentSection/Providers';
import { BasicPlanTabsContent } from './BasicPlanTabsContent';
import { EnterprisePlanTabsContent } from './EnterprisePlanTabsContent';
import { PlanTabsTrigger } from './PlanTabsTrigger';
import { ProPlanTabsContent } from './ProPlanTabsContent';

/**
 * 초기 활성화탭을 받아 플랜 선택을 표시합니다.
 * 초기 선택된 플랜과 최대 동시 접속 인원(maxCcu)을 받아 초기값으로 설정합니다.
 */
export const PlanTypeSelector = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    is일시납PRO사용중
  } = usePlanPaymentInfoContext();
  const {
    getValues,
    setValue
  } = usePlanPaymentFormContext();
  return <div className="w-full" data-sentry-component="PlanTypeSelector" data-sentry-source-file="PlanTypeSelector.tsx">
      <h2 className="text-[17px] font-[700] text-gray-900">
        {t('subscription:payment.planSelect.subTitle', '플랜 선택')}
      </h2>
      <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="PlanTypeSelector.tsx" />
      <div className="flex w-full flex-col items-center">
        <Controller defaultValue={getValues('planType')} name="planType" render={({
        field
      }) => <Tabs onValueChange={value => {
        field.onChange(value);
        if (value === 'basic' && getValues('maxCcu') < 20) {
          setValue('maxCcu', 20);
        }
      }} defaultValue={field.value}>
              <div className="flex w-full justify-center">
                <TabsList className="flex w-fit flex-row items-center gap-px rounded-[8px] border border-[#27262E0A] p-[2px]">
                  <PlanTabsTrigger className="h-[36px]" disabled={is일시납PRO사용중} value={'basic'}>
                    Basic
                  </PlanTabsTrigger>
                  <PlanTabsTrigger className="h-[36px]" value={'pro'}>
                    Pro
                  </PlanTabsTrigger>
                  <PlanTabsTrigger className="h-[36px]" value={'enterprise'}>
                    Enterprise
                  </PlanTabsTrigger>
                </TabsList>
              </div>
              <Spacing size={8} />
              <TabsContent value={'basic'} className="m-0">
                <BasicPlanTabsContent />
              </TabsContent>
              <TabsContent value={'pro'} className="m-0">
                <ProPlanTabsContent />
              </TabsContent>
              <TabsContent value={'enterprise'} className="m-0">
                <EnterprisePlanTabsContent />
              </TabsContent>
            </Tabs>} data-sentry-element="Controller" data-sentry-source-file="PlanTypeSelector.tsx" />
      </div>
    </div>;
};